import { Loader2, Inbox } from "lucide-react";
import { localeTag } from "@/i18n";

const short = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const today = new Date().toDateString() === d.toDateString();
  return today ? d.toLocaleTimeString(localeTag(), { hour: "2-digit", minute: "2-digit" }) : d.toLocaleDateString(localeTag(), { day: "2-digit", month: "short" });
};

export const MailList = ({ items, loading, error, selected, folder, onOpen }) => {
  if (loading) return <div className="flex justify-center py-16"><Loader2 className="w-5 h-5 animate-spin text-muted-foreground" /></div>;
  if (error) return <div className="p-6 text-sm text-rose-600" data-testid="mail-list-error">{error}</div>;
  if (!items.length) return <div className="p-10 text-center text-sm text-muted-foreground"><Inbox className="w-8 h-8 mx-auto mb-2 opacity-40" />Nessuna email</div>;
  return (
    <div className="divide-y divide-border" data-testid="mail-list" data-no-translate>
      {items.map((m) => (
        <button key={m.uid} type="button" onClick={() => onOpen(m)} data-testid={`mail-item-${m.uid}`}
          className={`w-full text-left px-4 py-3 transition-colors hover:bg-secondary/60 border-l-2 ${selected === m.uid ? "bg-primary/5 border-primary" : "border-transparent"}`}>
          <div className="flex items-center gap-2">
            {!m.seen && <span className="w-2 h-2 rounded-full bg-primary shrink-0" />}
            <span className={`truncate text-sm ${m.seen ? "text-foreground/80" : "font-bold"}`}>{folder === "SENT" ? `A: ${m.to}` : m.from_name}</span>
            <span className="ml-auto text-[11px] text-muted-foreground shrink-0">{short(m.date)}</span>
          </div>
          <div className={`text-sm truncate mt-0.5 ${m.seen ? "text-muted-foreground" : "font-medium"}`}>{m.subject}</div>
        </button>
      ))}
    </div>
  );
};

export default MailList;
